import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { InformationPageService } from 'src/app/services/informationPage.service';
import { Location } from '@angular/common';
import { HttpAlertService } from 'src/app/services/http-alert.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'information-page-editor',
  templateUrl: './information-page-editor.component.html',
  styleUrls: ['./information-page-editor.component.scss']
})
export class InformationPageEditorComponent implements OnInit {

  pageId: number;
  pageLang: string;
  pageContent: string;
  pageDesc: string;
  loader: boolean = true;
  isEditing: boolean = false;
  pagePreviousValue: string;

  constructor(
    private route: ActivatedRoute,
    private informationPageService: InformationPageService,
    public location: Location,
    private alertService: HttpAlertService,
    private translate: TranslateService) {
    this.route.params.subscribe(params => {
      this.pageId = params['id'];
      this.pageLang = params['lang'];
      this.pageDesc = params['desc'];
    });
  }

  ngOnInit(): void {
    this.informationPageService.getInformationPage(this.pageDesc, this.pageLang).subscribe((response: any) => {
      this.pageContent = response.data.page[Object.keys(response.data.page)[0]];
      this.loader = false;
    });
  }

  private updateInformationPage(): void {
    this.translate.get(['data_updated_success', 'data_updated_error']).subscribe(t => {
      this.informationPageService.updateInformationPage(this.pageDesc, this.pageLang, this.pageContent).subscribe(
        result => { this.alertService.success(t.data_updated_success); },
        error => { this.alertService.error(t.data_updated_error); }
      );
    });
  }

  public onStartEditing(): void {
    this.isEditing = true;
    this.pagePreviousValue = this.pageContent;
  }

  public onCancelEditing(): void {
    this.pageContent = this.pagePreviousValue;
    this.isEditing = false;
  }

  public onConfirmEditing(): void {
    this.updateInformationPage();
    this.isEditing = false;
  }

}